// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3BCzV","found":"Card_found__35yrB","card":"Card_card__1eE8R","flipped":"Card_flipped__2o8Eo","front":"Card_front__2MTpC","back":"Card_back__22bjH"};